import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LOGGER_FACTORY } from '../logger/logger-factory.provider';

interface VerisoulApi {
  account: (param: { id: string; email?: string | null }) => Promise<void>;
  reinitialize: () => Promise<void>;
}

@Injectable({
  providedIn: 'root',
})
export class VerisoulService {
  private readonly _platformId = inject<string>(PLATFORM_ID);
  private readonly _logger = inject(LOGGER_FACTORY).create('Verisoul');

  onAuth(uid: string, email?: string | null): void {
    if (!isPlatformBrowser(this._platformId)) return;

    const sdk = this._getSdk();
    if (!sdk) {
      this._logger.warn('Verisoul SDK not available');
      return;
    }

    sdk.account({ id: uid, email }).then(
      () => {
        this._logger.info('Verisoul SDK loaded and account registered');
      },
      (err: unknown) => {
        this._logger.warn('Verisoul account call failed', {
          error: err instanceof Error ? err.message : String(err),
        });
      },
    );
  }

  resetSession(): void {
    if (!isPlatformBrowser(this._platformId)) return;

    const sdk = this._getSdk();
    if (!sdk) {
      this._logger.warn('Verisoul SDK not available for resetSession, skipping');
      return;
    }

    sdk.reinitialize().catch((err: unknown) => {
      this._logger.warn('Verisoul reinitialize failed', { error: err instanceof Error ? err.message : String(err) });
    });
  }

  private _getSdk(): VerisoulApi | undefined {
    return (window as any).Verisoul as VerisoulApi | undefined;
  }
}
